import { tokenStore } from "../auth/tokenStore";

/** Member app user-voucher detail: {redirectUrl}/voucher/{userVoucherId}. */
export function buildMemberVoucherUrl(base, voucherId) {
  if (!base || !voucherId) return null;
  const b = String(base).trim().replace(/\/$/, "");
  const id = String(voucherId).trim();
  if (!id) return null;
  return `${b}/voucher/${encodeURIComponent(id)}`;
}

/**
 * Path for the host's VIO_NAVIGATE message (received voucher detail). The
 * Member App only accepts `voucher/<id>` with a [\w-] id; anything else is
 * ignored by the host, so return null and let the caller fall back.
 */
export function buildVioVoucherPath(userVoucherId) {
  const id = String(userVoucherId ?? "").trim();
  return /^[\w-]+$/.test(id) ? `voucher/${id}` : null;
}

export function getVoucherCompanyCode(voucher) {
  if (!voucher) {
    return null;
  }

  const rawCode =
    voucher.company?.companyCode ||
    voucher.company?.code ||
    voucher.company?.slug ||
    voucher.company?.name;

  if (!rawCode) {
    return null;
  }

  return String(rawCode)
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "");
}

function appendTenantPathIfNeeded(baseUrl, voucher) {
  const tenant = getVoucherCompanyCode(voucher);
  if (!baseUrl || !tenant) {
    return baseUrl;
  }

  try {
    const url = new URL(baseUrl);
    const hasTenantPath = url.pathname && url.pathname !== "/";
    if (!hasTenantPath) {
      url.pathname = `/${tenant}`;
    }
    return url.toString().replace(/\/$/, "");
  } catch {
    const base = String(baseUrl).trim().replace(/\/$/, "");
    return base.includes(`/${tenant}`) ? base : `${base}/${tenant}`;
  }
}

// Member App base from the host's redirectUrl (origin + tenant path).
export function getVoucherPwaBaseUrl(voucher) {
  return appendTenantPathIfNeeded(tokenStore.getRedirectUrl(), voucher);
}
